import axios from 'axios';
import { 
  getRegion, 
  getLocality,
 } from '../../api/api';
import { REQUEST_CATALOG, SUCCESS_CATALOG, ERROR_CATALOG, SUCCESS_LOCALITY, REQUEST_LOCALITY } from './action-types';

export const setCatalogs = data => {
  return {
    type: SUCCESS_CATALOG,
    payload: data,
  };
};

export function getCatalogs() {
  return function(dispatch) {
    dispatch({ type: REQUEST_CATALOG });
    axios
      .all([
        getRegion(),
      ])
      .then(
        axios.spread(( 
          region,
         
          ) => {
          const data = {
            region: region.data,
          };
          dispatch(setCatalogs(data));
        })
      )
      .catch(err => {
        dispatch({
          type: ERROR_CATALOG,
        });
      });
  };
}

export const setLocality = data => {
  return {
    type: SUCCESS_LOCALITY,
    payload: data,
  };
};

export const localityAction = region => (dispatch, getState) => {
  
    dispatch({type: REQUEST_LOCALITY})
    // console.log(getState().recipient.p_region)
    getLocality(region)
    .then(response => {
        if (response.data.length > 0) {
          const localityCatalog = response.data.map(item => {
            return {
              label: `${item.c_type}${item.c_name}`,
              value: item.id,
              district: item.district_name
            }
          })
          dispatch(setLocality(localityCatalog))
        }
        
    })

}
